<template>
	<div>
		<button
			class="button px-0 has-text-black-bis"
			v-tooltip="'Edit'"
			:disabled="getActiveFiles.length === 0"
			@click="isOpen = !isOpen"
		>
			<i
				class="icon-edit"
			></i>
		</button>
	</div>
	<o-modal :active="isOpen" :canCancel="false" class="modal-sm">
		<div class="modal-card">
			<header class="modal-card-head has-background-white">
				<div class="modal-card has-text-dark has-text-weight-bold">Edit Document(s)</div>
			</header>
			<section class="modal-card-body is-visible  has-background-white pt-2">
				<div class="is-italic has-text-weight-semibold line-height">
					Shipping order
				</div>
				<div class="has-text-weight-normal is-regular">
					{{ order.name }}
				</div>
				<div class="is-divider my-0"></div>
				<o-checkbox
					class=""
					v-model="markAllPrivate"
					@update:model-value="setDocsPermission"
				>
					<div class="is-italic has-text-weight-semibold ml-2">
						Mark file as Private
					</div>
				</o-checkbox>
				<div>
				<div class="file-lists">
					<VDropdown placement="auto" :shown="isEdit" :autoHide="false" v-if="isEdit">
						<template #popper>
							<div class="card">
								<header class="card-header">
									<h4 class="card-header-title is-size-3 has-text-black-bis
											has-text-weight-bold is-paddingless">
										{{ docToRename.type === 'url' ? 'Edit URL' : (docToRename.type === 'file' ? 'Edit Document' : 'Edit URL') }}
									</h4>
								</header>
								<section v-if="isPrefabDoc" class="card-content is-marginless has-background-white">
									<div class="column has-text-danger is-paddingless">{{ `This ${docToRename.type === 'file' ? 'document' : 'URL'} must be edited in its original Prefab Package `}}</div>
								</section>
								<section v-else class="card-content is-marginless has-background-white">
									<div class="control" v-if="docToRename.type !== 'file'">
										<span class="is-size-6 is-italic has-text-weight-normal is-pulled-right
												has-text-grey">
											(include http:// or https://)
										</span>
										<div class="field mb-5">
											<h3 class="is-size-3 has-text-black-bis">URL</h3>
											<input class="input" type="url" placeholder="Type or Paste URL" v-model.trim="docUrl"
												pattern="https?://.+" @input="resetWarning" />
										</div>
									</div>
									<div class="field">
										<div class="control">
											<div v-if="docToRename.type !== 'url'" class="mb-5">
												<h3 class="is-size-3 has-text-black-bis">Document Name</h3>
												<h3 class="is-size-3 has-text-black-bis has-text-weight-normal ">{{ docToRename.name }}</h3>
											</div>
											<h3 class="is-size-3 has-text-black-bis">Display Name</h3>
											<div class="is-flex is-justify-content-space-between">
												<input class="input mb-5 mr-2" type="text" v-model.trim="renameTo" @input="resetWarning" />
												<label class="line-height has-text-black-bis is-size-3">{{ docToRename.type === 'file' ?
													(docToRename.name.includes('.') ? '.' + docToRename.name.split('.').pop() : '') : '' }}</label>
											</div>
										</div>
									</div>
									<div class="column has-text-danger is-paddingless" v-if="warn">{{ warn }}</div>
								</section>
								<footer class="card-footer is-justify-content-flex-end">
									<div class="buttons">
										<button class="button is-outlined has-text-weight-bold is-size-5" @click="closeModal">
											Cancel
										</button>
										<button class="button is-dark has-text-weight-bold is-size-5" @click="saveName"
											:disabled="renameTo.length === 0">
											Save
										</button>
										<!-- <button v-if="isPrefabDoc" 
											class="button is-success has-text-weight-bold is-size-5" 
											@click="openPrefab">
											Open Prefab Package
										</button> -->
									</div>
								</footer>
							</div>
						</template>
					</VDropdown>
					<div v-for="file in getActiveFiles" :key="file.key" class="column document-row">
						<div class="columns">
							<div class="column px-0 is-narrow">
								<o-checkbox
									class="py-0"
									v-model="file.visible"
									trueValue="to-me"
									falseValue="to-all"
									@update:model-value="() => setEditable(file)"
								></o-checkbox>
							</div>
							<div class="column p-0">
								<div class="line-height p-1 has-text-weight-normal">
									{{ file.name }}
								</div>
							</div>
							<div class="column is-narrow p-1">
								<div class="buttons">
									<button class="button p-0 has-text-black-bis" v-if="file.type === 'url' || file.type === 'file'"
										:disabled="isEdit"
										@click="setEdit(file)">
										<i class="icon-edit"></i>
									</button>
									<button class="button p-0"
										@click="$emit('removeFile', file)"
										:disabled="!(canRemove(file) && !isDisabled)">
										<i class="icon-removedelete"></i>
								</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				</div>
			</section>
			<footer
				class="modal-card-foot is-justify-content-flex-end is-align-items-center has-background-white"
			>
				<div class="buttons">
					<button
						class="button is-outlined has-text-weight-bold"
						@click="$emit('close');isOpen = false"
					>
						Cancel
					</button>
					<button
						class="button has-text-weight-bold is-dark has-text-white"
						@click="confirmChanges"
					>
						Done
					</button>
				</div>
			</footer>
		</div>
		<o-loading
			:full-page="false"
			:active="isLoading"
			:can-cancel="false"
		></o-loading>
	</o-modal>
</template>

<script>
import { useToast } from 'vue-toastification';
import { every, isEmpty, some, uniq } from 'lodash';
import { computed, onBeforeMount, reactive, toRefs } from 'vue'

export default {
	name: 'Edit Files',
	props: {
    projectId: String,
    order: {
      type: Object,
      default: () => {},
    },
		files: {
      type: Array,
      default: () => [],
    },
		formChecklist: {
      type: Boolean,
      default: true,
    },
		closable: {
      type: [Boolean, Function],
      default: false,
    },
		isDisabled: { // need to verify and remove
      type: Boolean,
      default: false,
    },
		showCloseButton: {
      type: Boolean, // need to verify and remove
      default: true,
    },
	},
	setup(props, { emit }) {
		const toast = useToast();
		const data = reactive({
			warn: '',
			docUrl: '',
			renameTo: '',
			extension: '',
			isOpen: false,
			isEdit: false,
			docToRename: {},
			fileWithExtension: '',
			markAllPrivate: false,
		});

		const setDocsPermission = (val) => {
			props.files.forEach(f => {
				if ((val && f.visible === 'to-all') || (!val && f.visible === 'to-me') ) {
					f.edited = true;
				}
				f.visible = val ? 'to-me' : 'to-all';
			})
		}

		const checkAllPrivate = () => {
			data.markAllPrivate = every(props.files, { visible: 'to-me' });
		}

		const setEditable = (file) => {
			file.edited = true;
			checkAllPrivate();
		}

		onBeforeMount(() => {
			checkAllPrivate();
		})

		const canRemove = (file) => {
      if (file.type === 'form' && props.formChecklist
        && !(isEmpty(file.formData) && props.showCloseButton)) {
        return false;
      } if (!isEmpty(props.order)
        && !['Prefabs'].includes(props.order.__t)
        && some(file.sources, { stage: 'planning' })
        && file.type === 'form') {
        return false;
      } if (typeof props.closable === 'function') {
        return props.closable(file);
      }
      return props.closable;
    };

		const setEdit = (file) => {
			if (!file.updatedName) {
				file.updatedName = ''
			} else {
				data.renameTo = file.updatedName;
			}
			if (file.type === 'url') {
				data.docUrl = file.url;
			}
			data.extension = file.name.includes('.') ? `.${file.name.split('.').pop()}` : '';
			data.docToRename = file;
			data.isEdit = true
		}

		const resetEditModalData = () => {
			data.warn = '';
			data.docUrl = '';
			data.renameTo = '';
			data.extension = '';
			data.docToRename = {};
		}

		const closeModal = () => {
			data.isEdit = false;
			resetEditModalData();
		}

		const fetchExistingOrderFileNames = () => {
      let filteredFileNames = [];
      let todofilteredFileNames = [];
      let filteredSimpleFileNames = [];
       // get all the order files
       if (props.order.files && !isEmpty(props.order.files)) {
        const filterFiles = props.order.files.filter((file)=> !file.archived?.value)
        filteredFileNames = uniq(filterFiles.map((file) => file.name))
      }
      // get all the order todos
      if (props.order.todos && !isEmpty(props.order.todos)) {
        const filteredTodos = [];
        props.order.todos.forEach((todo) =>{
          if (todo.files && !isEmpty(todo.files)) {
            todo.files.forEach((file) => {
              if (!file.archived.value) {
                filteredTodos.push(file);
              }
            })
          }
        })
        todofilteredFileNames = uniq(filteredTodos.map((file) => file.name))
      }

      // get all the simple files
      if (props.order.simpleFiles && !isEmpty(props.order.simpleFiles)) {
        const filteredSimpleFiles = props.order.simpleFiles.filter((file) => !file.archived.value)
  
        filteredSimpleFileNames = _.uniq(filteredSimpleFiles.map((file) => file.name));
      }

      // existing uniq file names
      const existingOrderFileNames = _.uniq([...filteredFileNames, ...filteredSimpleFileNames, ...todofilteredFileNames]);
      return existingOrderFileNames;
    }

		const checkIfDuplicateExists = (fileName) => {
      const existingOrderFileNames = fetchExistingOrderFileNames();
      const finalList = [...existingOrderFileNames];
  
      finalList.push(fileName);

      // check if same file name already exists
      let duplicate = false;

      if (finalList.includes(fileName)) {
        const filteredName = finalList.filter((key) => key == fileName);
          if (filteredName.length > 1) {
            duplicate = true;
          }
      }
      return duplicate;
    }

		const saveName = () => {
			const pattern = /\b(http|https)/;
      const docName = data.renameTo.trim();
      if (docName.length < 3) {
        data.warn = 'Document name must contain at least 3 characters!';
      } else if (data.docToRename.type !== 'file' && !pattern.test(data.docUrl)) {
        data.warn = 'Warning! Please enter a valid URL';
      } else {
        if (data.docToRename.type === 'file') {
          data.fileWithExtension = docName + data.extension;
          if (data.docToRename.name !== data.fileWithExtension) {
            const isExistingFileInOrder = checkIfDuplicateExists(data.fileWithExtension);

            if (isExistingFileInOrder) {
              toast.error('Duplicate Files Found');
              return;
            }
          }
          if (props.order) {
            data.docToRename.edited = true;
          }
        }
        if (data.docToRename.type === 'url') {
          const newUrlName = docName + data.extension;

          if (data.docToRename.name !== newUrlName) {
            const isExistingUrlInOrder = checkIfDuplicateExists(newUrlName);
            if (isExistingUrlInOrder) {
              toast.error('Duplicate URL Found');
              return;
            }
          }
          data.docToRename.url = data.docUrl;
        }
      }
			data.isEdit = false;
			if (data.renameTo) {
				data.docToRename.name = data.renameTo + data.extension;
			}
			resetEditModalData()
		}

		const confirmChanges = () => {
			emit('saveDocs');
			data.isOpen = false
		}

		const getActiveFiles = computed(() => {
			return props.files.filter((file) => !file.archived.value);
		})

		return {
			...toRefs(data),
			setDocsPermission,
			checkAllPrivate,
			setEditable,
			canRemove,
			setEdit,
			closeModal,
			saveName,
			confirmChanges,
			getActiveFiles,
		}
	}
}
</script>

<style scoped>
	.o-modal__content .modal-card-head {
		border-bottom: none;
	}
	.o-modal__content .modal-card-foot {
		border-top: 1px solid #a6a6a6;
	}
	.is-divider {
		margin: 16px 0 !important;
		border-color: #999999;
	}
	.o-chk {
		justify-content: unset !important;
	}
	.buttons .button {
		margin: 0 !important;
	}
	.buttons .button:not(:last-child) {
		margin-right: 8px !important;
	}
	::v-deep(.card-header) {
		border-bottom: none !important;
		padding-bottom: 0 !important;
	}
</style>